var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro[data-v-f03a854c]{background-image:url(" + escape(require("../assets/images/temp/intro-image-2.png")) + ")}span[data-v-f03a854c]{font-style:italic;font-size:24px}", ""]);

// exports
